module.exports = __webpack_public_path__ + "static/media/chargext-3.298c2006.jpg";